import { theme } from "@src/theme";
import styled from "styled-components";
import RightArrow from "@assets/img/right-arrow.svg";
import TimesIcon from "@assets/img/times-icon.svg";

export const TopButtonsGroup = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: 50px;
  width: 100%;
`;

export const CloseDrawerButton = styled.button`
  background-color: ${theme.colors.gray300};
  color: ${theme.colors.yellow};
  border: 1px solid ${theme.colors.yellow};
  width: 30px;
  height: 30px;
  border-radius: 15px;
  cursor: pointer;
`;
export const SubmitDrawerButton = styled.button`
  opacity: ${({ disabled }): string => (disabled ? "0.5" : "1")};
  background-color: ${theme.colors.gray300};
  color: ${theme.colors.yellow};
  border: 1px solid ${theme.colors.yellow};
  width: 100px;
  height: 30px;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SubmitDrawerButtonWithIcon = ({
  disabled,
  ...props
}: {
  disabled: boolean;
}) => {
  return (
    <SubmitDrawerButton disabled={disabled} type="submit" {...props}>
      <img
        src={RightArrow}
        alt="Submit"
        style={{ height: "50%", objectFit: "contain" }}
      />
    </SubmitDrawerButton>
  );
};

export const CloseDrawerButtonWithIcon = ({
  onClick,
  disabled,
  ...props
}: {
  disabled: boolean;
  onClick: () => void;
}) => {
  return (
    <CloseDrawerButton
      onClick={onClick}
      type="button"
      disabled={disabled}
      {...props}
    >
      <img
        src={TimesIcon}
        alt="close"
        style={{ height: 10, width: 10, objectFit: "contain" }}
      />
    </CloseDrawerButton>
  );
};
